import {SSO_DOMAIN, defaultResponseHandler} from "helpers/utils.js";

export async function fetchPlotImages() {
  try {
    const response = await fetch(`${SSO_DOMAIN}/v1/plot-images`, {
      method: 'GET',
      credentials: 'include'
    });
    return defaultResponseHandler(response)
  } catch (error) {
    console.log(error);
    return null;
  }
}
